import { dataMember } from 'santee-dcts';

export interface DefaultColumnInfo {
    dBViewName?: string;
    viewDisplayName?: string;
    naturalKey?: string;
    appDataDefinitionId?: number;
    appDataColumnDefinitionId?: number;
    columnDisplayName?: string;
    dbViewColumnName?: string;
    sequence?: number;
    defaultPageSize?: number;
    defaultFlag?: boolean;
    mandatoryFlag?: boolean;
    hiddenFlag?: boolean;
    formatString?: string;
    dataType?: string;
    hyperlinkFlag?: boolean;
    hyperlinkRoute?: string;
    actionDbColumnName?: string;
    entity?: string;
    entityAttribute?: string;
    physicalEntity?: string;
    physicalEntityAttribute?: string;
    customSQL?: string;
    isNew?: boolean;
}

export interface ViewInfo {
    viewDisplayName?: string;
    appDataDefinitionId?: number;
    naturalKey?: string;
    dbViewName?: string;
}

export interface ViewList {
    viewDisplayName: string;
    appDataDefinitionId: number;
}

export class DefaultColumnModel {
    @dataMember()
    public defaultColumnsData: DefaultColumnInfo[];
}

export interface ViewColumnInfo {
    viewDisplayName: string;
    appDataDefinitionId: number;
    columnList: DefaultColumnInfo[];
}

export enum FormResultType {
    'delete' = 1,
    'save' = 2,
    'cancel' = 3
}

export interface FormResultInfo {
    resultType: FormResultType;
    columnInfo: DefaultColumnInfo;
}